<template>
  <v-container>
    <v-row>
      <v-col
          md="4"
          offset-md="4">
        <h2>Enter event code</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          md="4"
          offset-md="4">
        <v-text-field
            v-model="eventCode"
            label="Event Code"
            :rules="codeRules"
            hide-details="auto"
            autofocus></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          md="4"
          offset-md="4">
        <v-btn class="mr-4" color="success" v-on:click="submitEventCode">
          SUBMIT
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          md="12">
        <h4 class="mr-4">
          {{ this.$store.state.event }}
        </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    eventCode: "rob-test",
    codeRules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
    ]
  }),
  methods: {
    submitEventCode: function () {
      console.log(this.eventCode);
      this.$store.dispatch('bindEvent',{ id: this.eventCode });
      this.$store.dispatch('bindTeams',{ id: this.eventCode });
      this.$store.dispatch('bindBoatGroups',{ id: this.eventCode });
      this.$store.dispatch('bindRounds',{ id: this.eventCode });
      //this.$router.push({path: "/"}).catch(()=>{});
    }
  },

  watch: {

  },
}
</script>
